module.exports = [{"name":"מספר הנבחרות שמשתתפות במונדיאל ויגרמו לנו להגיד \"למה הם כן ואנחנו לא?!\"","icon":9},{"name":"מספר סרטוני המכות בין חוליגנים שתקבל לוואטסאפ שלך עד סוף הטורניר","icon":61},{"name":"מספר הפעמים שמותר לשדרן לספר לנו כמה אחוזים מתושבי איסלנד נמצאים באצטדיון לפני שזה הופך למעצבן","icon":1},{"name":"הסכום, בשקלים, שתוציא בפיצוצייה מתחת לבית שלך רק כי נזכרת בדקה ה-90 שבא לך לצפות במשחק עם איזה טילון"},{"name":"הסיכוי, באחוזים, שדווקא הדפקט הכי לא קשור בעבודה שלך ייקח את הפרס הגדול בטוטו-מונדיאל-משרדי אצלכם"},{"name":"יחס הפיסטוקים הסגורים לעומת הפיסטוקים הפתוחים בכל שקית שאי פעם קניתם"}]


//////////////////
// WEBPACK FOOTER
// ./src/api/GreenList.json
// module id = 24
// module chunks = 0